export default __webpack_public_path__ + "static/media/color-palette.2f64f3f3.svg";